//
// Module for the DROP Disbursement Periodic wizard's Initiate step
//
rs.module("participant/benefit/setup/dropdisbursement/periodic/wizard/initiatestep",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors) {

            // Get the wizard's next button
            var wizardNextButton = $(`[data-wizard]`).js("_next");

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var initiateOnlyCheckBox = stepContainer.js(jsSelectors.initiateOnlyCheckBox);

            // On initialize of page, appropriately set wizard's next button text (Next or Finish)
            setWizardNextButtonText();

            // Conditionally set display of Wizard's next button text (Next or Finish) based on InitiateOnlyCheckBox
            function setWizardNextButtonText() {

                // Get the Next button's HTML (contains text and spinner icon)
                var buttonHtml = wizardNextButton.html();

                // Conditionally update text portion of button's HTML based on initiateOnlyCheckBox
                if (initiateOnlyCheckBox.is(":checked")) {
                    wizardNextButton.html(buttonHtml.replace('Next', 'Finish'));
                }
                else {
                    wizardNextButton.html(buttonHtml.replace('Finish', 'Next'));
                }
            }

            // Handle initiateOnlyCheckBox change
            initiateOnlyCheckBox.change(function () {

                // Set wizard's next button text (Next or Finish)
                setWizardNextButtonText();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);